import { addSearchBoxInteractedTrackingEvent } from "@website/ticket-ui/common/helper/searchBoxInteractedTrackingEvents";
import { CabinType } from "@website/tracking/types";
import { useCallback, useEffect, useMemo, useState } from "react";

export const useFlightClass = (value: string) => {
  const [flightClass, setFlightClass] = useState<string>("ECONOMY");

  const flightClassList = useMemo(
    () => [
      { title: "اکونومی", value: "ECONOMY" },
      { title: "بیزینس", value: "BUSINESS" },
      {
        title: "فرست کلاس",
        value: "FIRST_CLASS"
      }
    ],
    []
  );
  useEffect(() => {
    value && setFlightClass(value);
  }, [value]);
  const onChangeFlightClass = useCallback((value: string) => {
    setFlightClass(value);
    addSearchBoxInteractedTrackingEvent({
      cabin_type: value as CabinType
    });
  }, []);

  return {
    flightClass,
    flightClassList,
    onChangeFlightClass
  };
};
